var _circle, _path, _path2, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.737,
    cy: 18.3288,
    r: 10.9137,
    fill: "#F2C94C",
    stroke: "#000721",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9908 35.4594H21.0256C18.2966 35.4594 16.0844 37.6716 16.0844 40.4006V57.3343C16.0844 60.0633 18.2966 62.2755 21.0256 62.2755H22.9908C25.7197 62.2755 27.932 60.0633 27.932 57.3343V40.4006C27.932 37.6716 25.7197 35.4594 22.9908 35.4594Z",
    stroke: "white",
    strokeWidth: 3.29412
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8993 41.3676L50.8872 41.3629L50.8751 41.3584L35.9078 35.7714C35.355 35.5651 34.7698 35.4594 34.1798 35.4594H33.8561C31.1272 35.4594 28.915 37.6716 28.915 40.4006V53.9029C28.915 56.1139 30.3837 58.0557 32.5112 58.6575L44.0424 61.9192C45.0557 62.2058 46.1341 62.1612 47.1203 61.7918L61.077 56.5646C62.034 56.2062 62.9225 55.5222 63.4505 54.6065C64.0071 53.6412 64.1697 52.3637 63.4498 51.1698C62.4154 49.4542 60.5322 48.2896 58.3608 48.2896H52.3013C53.0966 47.5297 53.5927 46.4592 53.5927 45.275C53.5927 43.5237 52.4903 41.9902 50.8993 41.3676Z",
    stroke: "white",
    strokeWidth: 3.29412
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5755,
    cy: 27.9246,
    r: 11.4584,
    stroke: "white",
    strokeWidth: 3.29412
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayout);
export default __webpack_public_path__ + "static/media/payout.556b6396d38f6390362ff08f7d5a0c19.svg";
export { ForwardRef as ReactComponent };